import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';

// ------------------------------------
// Store
// ------------------------------------
export const STORE_KEY = 'startBench';

const startBenchReducer = (state = {}) => state;

export default startBenchReducer;

// ------------------------------------
// View / Route
// ------------------------------------
export const START_BENCH_VIEW = `${STORE_KEY}/START_BENCH_VIEW`;

viewNames[START_BENCH_VIEW] = 'StartBench';
routes[START_BENCH_VIEW] = {
  path: '/in-season/fantasy-football-start-sit-tool',
};



// WEBPACK FOOTER //
// ./src/app/views/StartBench/module/startBench.js